module.exports = __webpack_public_path__ + "img/sld_inverter_green_dark.f81a31f1.svg";